import { Card, Typography, Image } from "antd";
import img_mantenimiento from "../../assets/general/construction.png";

const { Title, Text } = Typography;

const Mantenimiento = () => {
  return (
    <Card
      style={{
        maxWidth: "80%",
        margin: "auto",
        marginTop: 50,
        textAlign: "center",
        borderRadius: 16,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      <Image
        src={img_mantenimiento}
        alt="Mantenimiento"
        width="70%"
        preview={false}
        style={{ marginBottom: 20 }}
      />
      <Title level={4}>
        Estamos trabajando para brindarte un mejor servicio
      </Title>
      <Text type="secondary">
        La vista se está actualizando, por favor espera un momento.
      </Text>
    </Card>
  );
};

export default Mantenimiento;
